import React, { useState, useEffect, useContext } from "react";
import "./shop.css"
import { Context } from "../../app";
import { Mixpanel } from "../../Mixpanel";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import Product from "../../components/product/product";
import ProductDisplay from "../../components/productDisplay/productDisplay";
import Filter from "../../components/filter/filter";

function Shop() {
    
    
    
    const [filtered, setFiltered] = useState([])
    const [searchParams, setSearchParams] = useSearchParams()
    const [expand, setExpand] = useState(false)


    let filter = searchParams.get("filter")?searchParams.get("filter"):"All"
    const shop = useContext(Context)

    useEffect(()=>{
        
        shop.setShowNav(true)
        
        if (searchParams.get("filter")) {
            shop.setFilter(searchParams.get("filter"))
        }
    },[])

    useEffect(()=>{
        // console.log("yo")
        shop.ReactPixel.trackCustom("ShopView", {
            page: searchParams.get("filter")?searchParams.get("filter"):shop.filter
        })
        shop.setShowPages(true)
        shop.setShowCart(false)
        shop.setStage(0)
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        // console.log("device")
        if (params.device) {
            shop.setPage(params.device)
        }
        if (params.id) {
            shop.setPage(params.id.split("-")[0]==="NEX"?"Nexum":"Nexum Mini")
            // console.log("here")
        }
        axios({
            url:shop.url+"products",
            method:"GET"
        }).then((res)=>{
            // console.log(res)
            let sorted = res.data.filter((prod)=>prod.id.includes("BUN"))
            let prods = res.data.filter((prod)=>!prod.id.includes("BUN"))
            // console.log(sorted)
            // console.log(prods)

            // console.log(searchParams.get("filter"))
            shop.setProducts([...prods, ...sorted])
            filterProducts(searchParams.get("filter")?searchParams.get("filter"):"All", [...prods, ...sorted])
        }).catch((e)=>{
            console.log(e)
            alert("Error when connecting to Server. Try again later")
        })
    },[])

    useEffect(()=>{
        if (shop.products) {
            filterProducts(searchParams.get("filter")?searchParams.get("filter"):shop.filter, shop.products)
            window.scroll({
                top:0,
                left:0
            })
        }
        
        
    },[shop.filter])


    useEffect(()=>{
        // console.log("mpID",shop.mpid)
       
        if (shop.mpid) {
            axios({
                url:shop.url+"mixpanel",
                method:"POST",
                headers:{"Content-Type":"application/json"},
                data:{
                    event:"shopView",
                    properties:{
                        page: searchParams.get("filter")?searchParams.get("filter"):shop.filter
                    },
                    id:shop.mpid
                }
            }).then((res)=>{
                // localStorage.setItem("mp_uid", res.data.uid)
            })
            .catch((e)=>console.log(e))
        }
        
        
        
    }, [shop.mpid])


    function filterProducts(category, prods) {
        // console.log("filtering", category)
        if (category === "All") {

            
            setFiltered(prods.filter((prod)=>prod.category!=="Bundle"))
        }
        else {
            setFiltered(prods.filter((prod)=>prod.category===category))
        }
    }

    return(
        <div className="shop">
            {
                !shop.productview?
                <>
                {/* <button onClick={()=>setExpand(true)} className="filter-button">
                    {shop.filter}
                </button> */}
                {/* <Filter 
                    expand={expand}
                    setExpand={setExpand}
                    // filters={filters}
                    // filter={filter}
                    // setFilter={setFilter}
                /> */}
                <div className="products-grid">
                    {
                        filtered.map((product)=>{
                            if (!product.hide) {
                                return(
                                    <Product 
                                        id={product.id}
                                        name={product.name}
                                        price={product.price}
                                        discount={product.discount}
                                        img={product.picture}
                                        info={product.info}
                                        
                                        color={product.color}
                                        colors={product.colors}
                                    />
                                )
                            }
                            
                        })
                        
                    }
                </div>
                </>
                :
                {/* <ShopNexum 
                    id={shop.products.filter((product)=>product.name===shop.id)[0]?.id}
                    name={shop.products.filter((product)=>product.name===shop.id)[0]?.name}
                    price={shop.products.filter((product)=>product.name===shop.id)[0]?.price}
                    discount={shop.products.filter((product)=>product.name===shop.id)[0]?.discount}
                    img={shop.products.filter((product)=>product.name===shop.id)[0]?.picture}
                    info={shop.products.filter((product)=>product.name===shop.id)[0]?.info}
                    color={shop.products.filter((product)=>product.name===shop.id)[0]?.color}
                    colors={shop.products.filter((product)=>product.name===shop.id)[0]?.colors}
                    variant={shop.products.filter((product)=>product.name===shop.id)[0]?.variant}
                    variants={shop.products.filter((product)=>product.name===shop.id)[0]?.variants}
                    features={shop.products.filter((product)=>product.name===shop.id)[0]?.features}
                    description={shop.products.filter((product)=>product.name===shop.id)[0]?.description}
                    body={shop.products.filter((product)=>product.name===shop.id)[0]?.body}
                    bodies={shop.products.filter((product)=>product.name===shop.id)[0]?.bodies}
                /> */}
            }
            
        </div>
    )
}

export default Shop